import auth0 from 'auth0-js'
import EventEmitter from 'events'
import authConfig from '@/../auth_config.json'

import store from '@/store/store.js'
/* eslint-disable */ 

// 'loggedIn' is used in other parts of application. So, Don't forget to change there also
const localStorageKey = 'loggedIn'

const tokenExpiryKey = 'tokenExpiry'
const loginEvent = 'loginEvent'

const webAuth = new auth0.WebAuth({
  domain: authConfig.domain,
  redirectUri: `${window.location.origin + process.env.BASE_URL}callback`,
  clientID: authConfig.clientId,
  responseType: 'id_token',
  scope: 'openid profile email'
})

class AuthService extends EventEmitter {

    idToken = null;
    profile = null;
    tokenExpiry = null;

    // Starts the user login flow
    login (customState) {
      webAuth.authorize({
        appState: customState
      })
    }

    // Handles the callback request from Auth0
    handleAuthentication () {
      return new Promise((resolve, reject) => {
        webAuth.parseHash((err, authResult) => {
          if (err) {
            alert(`${err.error}. Detailed error can be found in console.`)
            reject(err)
          } else {
            this.localLogin(authResult)
            resolve(authResult.idToken)
          }
        })
      })
    }

    localLogin (authResult) {
      this.idToken = authResult.idToken
      this.profile = authResult.idTokenPayload

      // Convert the JWT expiry time from seconds to milliseconds
      this.tokenExpiry = new Date(this.profile.exp * 1000)
      localStorage.setItem(tokenExpiryKey, this.tokenExpiry)
      localStorage.setItem(localStorageKey, 'true')

      store.commit('UPDATE_USER_INFO', {
        displayName: this.profile.name,
        email: this.profile.email,
        photoURL: this.profile.picture,
        providerId: this.profile.sub.substr(0, this.profile.sub.indexOf('|')),
        uid: this.profile.sub
      })

      this.emit(loginEvent, {
        loggedIn: true,
        profile: authResult.idTokenPayload,
        state: authResult.appState || {}
      })
    }

    renewTokens () {
      // reject can be used as parameter in promise for using reject
      return new Promise((resolve) => {
        if (localStorage.getItem(localStorageKey) !== 'true') {
          // return reject("Not logged in");
        }

        webAuth.checkSession({}, (err, authResult) => {
          if (err) {
            // reject(err);
          } else {
            this.localLogin(authResult)
            resolve(authResult)
          }
        })
      })
    }

    logOut () {
      localStorage.removeItem(localStorageKey)
      localStorage.removeItem(tokenExpiryKey)
      localStorage.removeItem('userInfo')

      this.idToken = null
      this.tokenExpiry = null
      this.profile = null

      webAuth.logout({
        returnTo: window.location.origin + process.env.BASE_URL
      })

      this.emit(loginEvent, { loggedIn: false })
    }

    isAuthenticated () {
      return (
        // //new Date(Date.now()) < new Date(localStorage.getItem(tokenExpiryKey)) &&
        // (localStorage.getItem('accessToken') &&
        (localStorage.getItem('userInfo') &&
        localStorage.getItem(localStorageKey)) === 'true'
      )
    }

    hasEditPermissions (route) {
      // Checks if user has permission to edit in the route passed as parameter
      if (route.meta.editPermission) {
        let foundPermission = false
        
        const userInfo = JSON.parse(localStorage.getItem('userInfo'))
        route.meta.editPermission.forEach(el => {
          if (userInfo.permissionsCodes.length > 0 && userInfo.permissionsCodes.filter(a => a === el)[0]) {
            foundPermission = true
          }
        })
        
        if (!foundPermission) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
      // If editPermissions is not an array - only 1 value
      // if (route.meta.editPermission) {
      // return store.state.AppActiveUser.permissionsCodes.indexOf(route.meta.editPermission) !== -1 
      // } else {
      //   return true
      // }
    }

    hasEditPermissionCode (code) {
      // Checks if user has permission to edit a given section - passed through a permissionCode checked
      return store.state.AppActiveUser.permissionsCodes.indexOf(code) !== -1 
     
    }

    // Checks if user has permission to access / view to route.
    // Compares 2 indexes -> any of ther router permissions contained in user permissionCodes.
    // Could be used for editPermissions, as well as viewPermissions
    hasViewPermissionCode (routerPermissions) {
      // Si la ruta/menu no declara permisos (undefined o []) la consideramos
      // pública: cualquier usuario logueado puede verla. Antes esto crasheaba
      // con "Cannot read properties of undefined (reading 'forEach')".
      if (!routerPermissions || routerPermissions.length === 0) return 0

      // Was having synchronation problems. Make sure it checks all before returning.
      var checked = false
      var index = -1

      if (store.state.AppActiveUser.permissionsCodes.length > 0) {
        routerPermissions.forEach(el => {
          if (store.state.AppActiveUser.permissionsCodes.indexOf(el) >= 0) {
            index = store.state.AppActiveUser.permissionsCodes.indexOf(el)
          }
        })

        checked = true
      } else {
        checked = true
      }

      if (checked) {
        return index
      }
    }
    
    tokenExpired (error) { 
      // If authorized by endpoint - returns true. If not authorized, deletes localStorage
      if (error.message && error.message.toLowerCase().includes('invalid access token')) {
        // localStorage.removeItem('accessToken')
        localStorage.removeItem('userInfo')
        localStorage.removeItem('loggedIn')

        return true

      } else {
        return false
      }
    }
}

export default new AuthService()
